import { combineReducers } from 'redux';

import showcases from './showcases-reducer';
import categories from './categories-reducer';
import selectedCategory from './selectedCategory-reducer';
import searchTerm from './searchTerm-reducer';
import changeNumber from './changeNumber-reducer';
import disclaimer from './disclaimer-reducer';
import pagination from './pagination-reducer';
import selectedBadge from './selectedBadge-reducer';
import badges from './badges-reducer';

export default combineReducers( { showcases, categories, selectedCategory, searchTerm, changeNumber, disclaimer, pagination, selectedBadge, badges } );